import React from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import { Button } from "../components/ui/button";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <div className="mx-auto flex max-w-md flex-col items-center px-4 py-24 text-center">
        <h1 className="text-6xl font-bold text-primary">404</h1>
        <h2 className="mt-4 text-xl font-semibold">Página no encontrada</h2>
        <p className="mt-2 text-muted-foreground">
          Lo sentimos, la página que buscas no existe.
        </p>
        <Button className="mt-6" onClick={() => navigate("/")}>
          Ir al inicio
        </Button>
      </div>
    </PageLayout>
  );
};

export default NotFound;
